import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class CancelBtnComponent extends Vue {
    public cancel() {
        window.history.back();
    }
}
